__turbopack_context__.v({
  "className": "onest_94af13d6-module__V2DZuW__className",
});
